export default __webpack_public_path__ + "static/media/pawn_knight_wolf.ce474674.png";